import * as account from './account/selectors';
import * as authenticate from './authenticate/selectors';
import * as check from './check/selectors';
import * as confirmAccount from './confirmAccount/selectors';
import * as income from './income/selectors';
import * as incomeForm from './incomeForm/selectors';
import * as profile from './profile/selectors';
import * as tac from './tac/selectors';
import * as track from './track/selectors';
import * as registerAccount from './registerAccount/selectors';
import * as flash from './flash/selectors';
import * as storage from './storage/selectors';
import * as counter from './counter/selectors';
import * as email from './email/selectors';

export const getAccount = state => account.getAccount(state.account);
export const getAccountLoading = state => account.getLoading(state.account);

export const getAuthenticating = state => authenticate.getAuthenticating(state.authenticate);
export const getAuthenticateFromFrame = state => authenticate.getFromFrame(state.authenticate);
export const getAuthenticateUserToken = state => authenticate.getUserToken(state.authenticate);
export const getAuthenticatedUser = state =>
  authenticate.getAuthenticatedUser(state.authenticate);

export const getCheckLoading = state => check.getLoading(state.check);
export const getCheck = state => check.getCheck(state.check);
export const getCheckStatus = state => check.getStatus(state.check);

export const getConfirmingAccount = state =>
  confirmAccount.getConfirmingAccount(state.confirmAccount);
export const getConfirmCodeDestination = state =>
  confirmAccount.getDestination(state.confirmAccount);

export const getIncome = state => income.getIncome(state.income);
export const getIncomeLoading = state => income.getLoading(state.income);

export const getIncomeForm = state => incomeForm.getIncomeForm(state.incomeForm);

export const getProfile = state => profile.getProfile(state.profile);
export const getProfileLoading = state => profile.getLoading(state.profile);

export const getTac = state => tac.getTac(state.tac);
export const getTacLoading = state => tac.getLoading(state.tac);

export const getIDTrack = state => track.getTrack(state.track);

export const getRegisteringAccount = state =>
  registerAccount.getRegisteringAccount(state.registerAccount);

export const getFlashMessage = state => flash.getFlashMessage(state.flash);
export const getFlashShow = state => flash.getFlashMessage(state.flash);
export const getFlashType = state => flash.getFlashType(state.flash);
export const getFlashDuration = state => flash.getFlashDuration(state.flash);

export const getStore = state => storage.getStore(state.storage);
export const getCurrent = state => storage.getCurrent(state.storage);
export const getProjectType = state => storage.getProjectType(state.storage);
export const getOwnershipType = state => storage.getOwnershipType(state.storage);
export const getProjectName = state => storage.getProjectName(state.storage);
export const getProjectDetails = state => storage.getProjectDetails(state.storage);
export const getLoanAmount = state => storage.getLoanAmount(state.storage);
export const getValidateLoanAmount = state => storage.getValidateLoanAmount(state.storage);
export const getSelectedBank = state => storage.getSelectedBank(state.storage);
export const getAgreement = state => storage.getAgreement(state.storage);

export const getIcRetry = state => counter.getIcRetry(state.counter);
export const getIcVerifyRetry = state => counter.getIcVerifyRetry(state.counter);

export const getEmailLoading = state => email.getLoading(state.email);



// WEBPACK FOOTER //
// ./src/redux/selectors.js